var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registration-steps"},[_c('ul',{staticClass:"steps-indicator"},_vm._l((_vm.steps),function(step){return _c('li',{key:step.path},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(step.index <= 5),expression:"step.index <= 5"}],staticClass:"indicator-bullet",class:{
          active:
            _vm.currentRegistrationStep === step.index ||
            (_vm.totalStep - step.index === 1 && _vm.currentRegistrationStep >= 5),
          done: step.done,
        },on:{"click":function($event){return _vm.stepClicked(step)}}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }